import { create } from 'zustand';

const useSessionStore = create((set) => ({
    session: null,
    storeSession: (session) => set(() => ({ session: session })),
    token: null,
    storeToken: (token) => set(() => ({ token: token })),
    newAccount: null,
    storeNewAccount: (newAccount) => set(() => ({ newAccount: newAccount })),
    domain: null,
    setDomain: (domain) => set(() => ({ domain: domain }))
}));

export default useSessionStore;